import { OperatorsDetail } from '@/model/CommonModel';
import { Button, Checkbox, Divider, List, Typography } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import VirtualList from 'rc-virtual-list';
import React, { FC } from 'react';
import { BadgeStudioFilterBy } from '../../../model/BadgeModel';
import styles from './filterByContent.module.scss';

const { Text } = Typography;

type Props = {
	filterByData: BadgeStudioFilterBy;
	operators: OperatorsDetail[];
	setFilterByData: (filterData) => void;
	onClearFilterBy: () => void;
	onFilterBy: () => void;
};

const itemHeight: number = 30;
const getVirtualListHeight = (length: number): number => {
	let listHeight = 150;
	if (length <= 5) {
		listHeight = itemHeight * length;
	}

	return listHeight;
};

const FilterByContent: FC<Props> = ({ filterByData, operators, setFilterByData, onClearFilterBy, onFilterBy }) => {
	const onChangeOperatorName = (e: CheckboxChangeEvent, operator: OperatorsDetail) => {
		if (e.target.checked) {
			setFilterByData(prevState => ({ ...prevState, OperatorName: [...prevState.OperatorName, operator] }));
		} else {
			setFilterByData(prevState => ({ ...prevState, OperatorName: prevState.OperatorName.filter(x => x.Id !== operator.Id) }));
		}
	};

	const enableApplyFilter = filterByData.DoubleSided || filterByData.Portrait || filterByData.Landscape || filterByData.OperatorName.length > 0;

	return (
		<div className={styles.container}>
			<div>
				<Checkbox checked={filterByData.DoubleSided} onChange={e => setFilterByData(prevState => ({ ...prevState, DoubleSided: e.target.checked }))}>
					{_('DoubleSided')}
				</Checkbox>
			</div>
			{operators.length > 0 && (
				<>
					<span>{_('CreatedBy')}:</span>
					<div>
						<List split={false} size='small' className={styles.createdByList}>
							<VirtualList data={operators} height={getVirtualListHeight(operators.length)} itemHeight={itemHeight} itemKey='id'>
								{(operators: OperatorsDetail, index) => (
									<List.Item key={index}>
										<div>
											<Checkbox
												checked={filterByData.OperatorName.find(x => x.Id === operators.Id) !== undefined}
												onChange={e => onChangeOperatorName(e, operators)}>
												<Text className={styles.operatorName} ellipsis={{ tooltip: { title: operators.Name, placement: 'right' } }}>
													{operators.Name}
												</Text>
											</Checkbox>
										</div>
									</List.Item>
								)}
							</VirtualList>
						</List>
					</div>
				</>
			)}
			<div>
				<Checkbox checked={filterByData.Portrait} onChange={e => setFilterByData(prevState => ({ ...prevState, Portrait: e.target.checked }))}>
					{_('Portrait')}
				</Checkbox>
			</div>
			<div>
				<Checkbox checked={filterByData.Landscape} onChange={e => setFilterByData(prevState => ({ ...prevState, Landscape: e.target.checked }))}>
					{_('Landscape')}
				</Checkbox>
			</div>
			<Divider className={styles.divider} />
			<div className={styles.footer}>
				<Button onClick={onClearFilterBy}>{_('Reset')}</Button>
				<Button type='primary' onClick={onFilterBy} disabled={!enableApplyFilter}>
					{_('Filter')}
				</Button>
			</div>
		</div>
	);
};

export { FilterByContent };
